import React from "react";
import { formatDate, getAssessmentBadgeClass } from "../../../utils/dateFormatting";

const formatDateForModal = (dateStr) => formatDate(dateStr) || 'N/A';

export default function SessionDetailsModal({ show, onClose, selectedSessionDetails, sessionNotes, setSessionNotes }) {
  if (!show || !selectedSessionDetails) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
        <h2>Session Details</h2>
        <div className="session-details">
          <p><strong>Date:</strong> {formatDateForModal(selectedSessionDetails.session_date)}</p>
          <p><strong>Duration:</strong> {selectedSessionDetails.duration_seconds ? `${selectedSessionDetails.duration_seconds} seconds` : 'N/A'}</p>
          {selectedSessionDetails.emotion && (
            <div>
              <p><strong>Emotion Analysis:</strong></p>
              <ul>
                <li>Joy: {selectedSessionDetails.emotion.joy?.toFixed(1)}%</li>
                <li>Stress: {selectedSessionDetails.emotion.stress?.toFixed(1)}%</li>
                <li>Sadness: {selectedSessionDetails.emotion.sadness?.toFixed(1)}%</li>
                <li>Anger: {selectedSessionDetails.emotion.anger?.toFixed(1)}%</li>
                <li>Burnout Score: {selectedSessionDetails.emotion.burnout_score?.toFixed(1)}%</li>
              </ul>
              <p><strong>Assessment:</strong>
                <span className={`badge ${getAssessmentBadgeClass(selectedSessionDetails.emotion.doctor_assessment)}`}>
                  {selectedSessionDetails.emotion.doctor_assessment || 'N/A'}
                </span>
              </p>
            </div>
          )}
          <div className="notes-container">
            <p><strong>Session Notes:</strong></p>
            {sessionNotes.length === 0 ? (
              <p style={{ fontStyle: 'italic', color: '#6b7280' }}>No notes available.</p>
            ) : (
              <div>
                {sessionNotes.map((note) => (
                  <div key={note.note_id} className="note-item">
                    <p className="note-date">
                      {formatDateForModal(note.created_at)}
                    </p>
                    <p className="note-text">{note.note_text}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <button className="btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
